/* ============================================================================
   MALSERA — ms-animations.js
   Dos animaciones disparadas por IntersectionObserver, más la cascada.
   Sin GSAP, sin AOS: es exactamente lo que hace la referencia.

   Las animaciones son lo último que se añade. Si se meten antes, cualquier
   fallo de maquetación queda escondido detrás de un elemento que todavía
   no ha aparecido.
   ============================================================================ */

(() => {
  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Marca el documento antes de pintar. Solo a partir de aquí existe el
  // estado inicial oculto: si este script no llega, todo se ve.
  document.documentElement.classList.add('ms-anim-lista');

  const arrancar = () => {
    const elementos = document.querySelectorAll('.ms-anim');
    if (!elementos.length) return;

    // Con movimiento reducido no se observa nada: todo directo a su estado final.
    if (reducido.matches || !('IntersectionObserver' in window)) {
      elementos.forEach((elemento) => elemento.classList.add('is-in'));
      return;
    }

    // Numera los hijos de cada contenedor en cascada. Máximo 12: a partir de
    // ahí todos comparten el retardo del elemento 12.
    document.querySelectorAll('[data-cascade]').forEach((contenedor) => {
      [...contenedor.children].forEach((hijo, indice) => {
        hijo.classList.add('ms-anim', 'ms-anim--fade');
        hijo.style.setProperty('--animation-order', Math.min(indice, 12));
      });
    });

    const observador = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((entrada) => {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('is-in');
          observador.unobserve(entrada.target); // una sola vez por elemento
        });
      },
      { rootMargin: '0px 0px -50px 0px', threshold: 0.1 }
    );

    document.querySelectorAll('.ms-anim:not(.is-in)').forEach((elemento) => {
      // Un umbral del 10 % no se alcanza nunca en un bloque más alto que la
      // ventana: entra por arriba y por abajo a la vez sin llegar al 10 %
      // visible. Esos se muestran directamente.
      if (elemento.getBoundingClientRect().height > window.innerHeight * 0.9) {
        elemento.classList.add('is-in');
        return;
      }
      observador.observe(elemento);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }

  // Los bloques que llegan después de cargar la página (los relacionados, el
  // carrito repintado) traen elementos .ms-anim que nadie ha observado, y se
  // quedarían invisibles para siempre. Se vuelve a pasar por ellos.
  document.addEventListener('ms:contenido-nuevo', arrancar);
})();
